// RHFTextarea.jsx

import React from "react";
import { Textarea } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";

const RHFTextarea = ({
  name,
  rules,
  defaultValue = "",
  autosize = true,
  minRows = 3,
  maxRows,
  resize = "vertical",
  capitalizeFirst = false,
  trimOnBlur = false,
  onValueChange,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        const handleChange = (event) => {
          let value = event.currentTarget.value;

          if (capitalizeFirst && value.length > 0) {
            value =
              value.charAt(0).toUpperCase() +
              value.slice(1);
          }

          field.onChange(value);

          if (onValueChange) {
            onValueChange(value);
          }
        };

        const handleBlur = (event) => {
          let value = event.currentTarget.value;

          if (trimOnBlur) {
            value = value.trim();
            field.onChange(value);
          }

          field.onBlur();

          props.onBlur?.(event);
        };

        return (
          <Textarea
            {...props}
            {...field}
            value={field.value ?? ""}
            error={error?.message}
            autosize={autosize}
            minRows={minRows}
            maxRows={maxRows}
            resize={resize}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        );
      }}
    />
  );
};

export default RHFTextarea;